<template>
<div id="app">
  <v-app id="inspire">
    <v-app-bar
      app
      color="dark"
      dark
    >
    <v-toolbar-title>Graph Layout Labelling</v-toolbar-title>
    <v-spacer></v-spacer>
    <router-link to = "/" tag="button">
    <v-btn
            class="ma-2"
            large
            dark
            >User Login
            <v-icon dark class="ml-3"> mdi-account </v-icon>
    </v-btn>
    </router-link>
    </v-app-bar>
    <v-main>
        <v-card>
          <v-card-actions class="justify-center"> 
          <div class="text-h5 pa-5">Thank you so much for your contribution!</div>
          </v-card-actions>
          <v-card-actions class="justify-center"> 
          <div class="text-h5 pa-5">You have labeled <span class = "font-weight-black">{{count_labeled_graph}}</span> graphs in total.</div>
          </v-card-actions>
          <v-card-actions class="justify-center"> 
          <div v-if=avg_spent class="text-h5 pa-5">You spent <span class = "font-weight-black">{{avg_spent}}</span> seconds per graph on average.</div>
          </v-card-actions>
          <div v-if=is_admin>
          <div class="text-h6 pa-5 font-italic">Percentage of graphs have been labeled by one person</div>        
          <v-progress-linear
              v-bind:value = "label_once_perc"
              height = "25"
              color = "red lighten-2"
            >  
            <strong>{{label_once_perc}}%</strong>
          </v-progress-linear>
          
          <div class="text-h6 pa-5 font-italic">Percentage of graphs have been labeled by two person</div>        
          <v-progress-linear
              v-bind:value = "label_twice_perc"
              height = "25"
              color="teal lighten-2"
            >  
            <strong>{{label_twice_perc}}%</strong>
          </v-progress-linear>

          <div class="text-h6 pa-5 font-italic">Percentage of graphs have been labeled by three person</div>        
          <v-progress-linear
              v-bind:value = "label_thrice_perc"
              height = "25"
              color = "purple lighten-3"
            >  
            <strong>{{label_thrice_perc}}%</strong>
          </v-progress-linear>
          </div>
        </v-card>
    </v-main>
  </v-app>
</div>
</template>

<script>
export default {
  name:'End',
  title: 'Thank You',
  data() {
    return{
      count_labeled_graph:null,
      avg_spent:null,
      label_once_perc:null,
      label_twice_perc:null,
      label_thrice_perc:null,
      has_prev:true,
      user_id:this.$route.params.userid,
      is_admin:null
    }
  },
  created() {
    fetch(`http://localhost:5000/user_statistics/${this.user_id}/`,{
          method: "GET",
          headers:{
            "Content-Type": "application/json"
          }})
          .then(resp => {
            return resp.json()
          })
          .then(data => {
            this.count_labeled_graph = data.count_labeled_graph
            this.is_admin = data.is_admin
            this.avg_spent = data.avg_spent
            this.label_once_perc = data.label_once_perc
            this.label_twice_perc = data.label_twice_perc
            this.label_thrice_perc = data.label_thrice_perc
        })
  }
}
</script>
